import { scrollPosition } from "./scroll-position";
export var elementScrollPosition = function (element) {
    if (element === (element.ownerDocument || {}).body) {
        return scrollPosition(element);
    }
    return {
        x: element.scrollLeft,
        y: element.scrollTop
    };
};



//////////////////
// WEBPACK FOOTER
// ./~/@progress/kendo-popup-common/dist/es/element-scroll-position.js
// module id = 343
// module chunks = 93